
import { i18nText } from '@/locales';
export class ServiceCategoryNomenclatureForm {
    id?:number;
    name:string;
    online_appointment_name:string;

    constructor() {
        this.name = '';
        this.online_appointment_name = '';
    }
}
export const FormRules = {
    name: [
        { required: true, message: i18nText("Пожалуйста укажите наименование"), trigger: "change" },
    ],
    //online_appointment_name: [{ required: true, message: "Пожалуйста укажите описание", trigger: "change" }],

};
